import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { mobileIs } from "../../utils/siteUtils";

import './style.scss'
const IframePage = props => {
  const { lang, fields } = props;
  const { url, hasFooter } = fields;
  const isMobile = mobileIs()
  const [height, setHeight] = useState('calc(100vh - 60px)');

  useEffect(() => {
    if (isMobile) {
      setHeight('calc(100% - 60px)')
    } else {
      setHeight('calc(100vh - 60px)')
    }
  }, [])
  
  return (
    <div className={classNames('IframePage', {'active' : hasFooter})} style={{ height: height }}>			
      <iframe src={url.value} width="100%" height="100%"></iframe>
    </div>
  )
}
export default IframePage